import { render, staticRenderFns } from "./looksellGroupActive.vue?vue&type=template&id=0fc45b7c&scoped=true"
import script from "./looksellGroupActive.vue?vue&type=script&lang=js"
export * from "./looksellGroupActive.vue?vue&type=script&lang=js"
import style0 from "./looksellGroupActive.vue?vue&type=style&index=0&id=0fc45b7c&prod&lang=less&scoped=true"
import style1 from "./looksellGroupActive.vue?vue&type=style&index=1&id=0fc45b7c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc45b7c",
  null
  
)

export default component.exports